import { GridDataTableColumn } from "@src/components/global/v1/GridBuilder/GridDataTable/GridDataTableColumn";

// if we have access to the url, id of the business, the same accross all rows;
// var = parentid = queryString.Get("businessId")



/*

userGridBulkEditing:

Bulk editing we need to turn on the select column, 
a property to store the selected items, which already be on the grid
a confirm or close method to trigger the turning off of the select mode;

Actions:

When turned on the Id column is hidden, if clear perferences are clicked then prompt user to 
indicate if you do do this bulk editing will be canceled


boolean - handle state as on/off - modal from process is confimed or close then turn off selection;

OnOpen()
Open the selection column
Hiddle ID Column
disable clear preferences

***Close()
Close the selection;
Action.Refresh();



*/

export const columns: GridDataTableColumn[] = [
  {
    Header: "",
    accessor: "id",
    type: "number",
    width: 56,
    minWidth: 56,
    maxWidth: 56,
    linkColumn: true,
    linkUrl: "/crm/workspace/device-migration/{businessId}/scheduler/{value}",
    linkIcon: "edit",
    linkUrlHasPlaceHolder: true,
    linkShowValue: false,
    disableResizing: true,
    disableSortBy: true,
  },
  {
    accessor: "number",
    Header: "Number",
    width: 180,
  },
  {
    accessor: "buildType",
    Header: "Build Type",
    width: 180,
  },
  {
    accessor: "status",
    Header: "Status",
    width: 150,
  },
  {
    accessor: "statusDate",
    Header: "Status Date",
    width: 169,
    type: "date",
  },
  {
    accessor: "buildDate",
    Header: "Build Date",
    width: 169,
    type: "date",
  },
  {
    accessor: "migrationDate",
    Header: "Migration Date",
    width: 169,
    type: "date",
  },
  {
    accessor: "assignedTo",
    Header: "Assigned To",
    width: 180,
  },
  {
    accessor: "oldMachineName",
    Header: "Old Machine Name",
    width: 180,
  },
  {
    accessor: "serialNumber",
    Header: "Serial Number",
    width: 180,
  },
  {
    accessor: "userId",
    Header: "MSID",
    width: 180,
  },
  {
    accessor: "sourceUserId",
    Header: "NTID",
    width: 180,
  },
  {
    accessor: "errors",
    Header: "Errors",
    width: 180,
    ellipsisCell: true,
  },
  {
    accessor: "tags",
    Header: "Tags",
    width: 180,
  },
  {
    accessor: "noTaniumUpdate",
    Header: "No Tanium Update",
    width: 180,
    type: "boolean"
  },
  {
    accessor: "computerFormFactor",
    Header: "Computer Form Factor",
    width: 250,
  },
  {
    accessor: "processor",
    Header: "Processor",
    width: 400,
  },
  {
    accessor: "memory",
    Header: "Memory",
    width: 180,
  },
  {
    accessor: "driveCapacity",
    Header: "Drive Capacity",
    width: 180,
  },
  {
    accessor: "newMachineName",
    Header: "New Machine Name",
    width: 250,
  },
  {
    accessor: "deviceModelToDeploy",
    Header: "Device Model To Deploy",
    width: 250,
  },
  {
    accessor: "replaceDeviceType",
    Header: "Replace Device Type",
    width: 250,
  },
  {
    accessor: "recipientName",
    Header: "Recipient Name",
    width: 180,
  },
  {
    accessor: "employeeId",
    Header: "Employee Number",
    width: 180,
  },
  {
    accessor: "jobTitle",
    Header: "Job Title",
    width: 180,
  },
  {
    accessor: "employeeName",
    Header: "Employee Name",
    width: 180,
  },
  {
    accessor: "email",
    Header: "Email",
    width: 250,
  },
  {
    accessor: "phone",
    Header: "Phone",
    width: 180,
  },
  {
    accessor: "mailRoute",
    Header: "Peoplesoft Mail Route",
    width: 250,
  },
  {
    accessor: "cubeLocation",
    Header: "Cube Location",
    width: 180,
  },
  {
    accessor: "division",
    Header: "Division",
    width: 180,
  },
  {
    accessor: "shippingAddressType",
    Header: "Shipping Address Type",
    width: 180,
  },
  {
    accessor: "address1",
    Header: "Address 1",
    width: 250,
  },
  {
    accessor: "address2",
    Header: "Address 2",
    width: 250,
  },
  {
    accessor: "city",
    Header: "City",
    width: 180,
  },
  {
    accessor: "state",
    Header: "State",
    width: 180,
  },
  {
    accessor: "postal",
    Header: "Postal",
    width: 180,
  },
  {
    accessor: "country",
    Header: "Country",
    width: 180,
  },
  {
    accessor: "isAddressValid",
    Header: "Ship To Address Valid",
    width: 180,
    type: "boolean",
  },
  {
    accessor: "appset",
    Header: "Appset Number",
    width: 180,
  },
  {
    accessor: "shippingOptionName",
    Header: "Shipping Option",
    width: 180,
  },
  {
    accessor: "returnOptionName",
    Header: "Return Option",
    width: 180,
  },
  {
    accessor: "shippingCenterNumber",
    Header: "SCID",
    width: 180,
  },
  {
    accessor: "trackingNumber",
    Header: "Tracking Number",
    width: 180,
  },
  {
    accessor: "returnTrackingNumber",
    Header: "Return Tracking Number",
    width: 250,
  },
  {
    accessor: "deviceModelSent",
    Header: "Device Sent",
    width: 180,
  },
  {
    accessor: "buildStatus",
    Header: "CBP Primary Status",
    width: 180,
  },
  {
    accessor: "buildSecondaryStatus",
    Header: "CBP Secondary Status",
    width: 250,
  },
  {
    accessor: "buildResponseId",
    Header: "Build Response Id",
    width: 180,
    dataType: "Int64",
  },
  {
    accessor: "buildError",
    Header: "Build Error",
    width: 180,
  },
  {
    accessor: "isRecipientSameAsUser",
    Header: "Recipient Same As User",
    width: 250,
    type: "boolean",
  },
  {
    accessor: "Current Life Cycle Status",
    Header: "Current Life Cycle Status",
    width: 250,
  },
  {
    accessor: "currentMachineName",
    Header: "Current Machine Name",
    width: 250,
  },
  {
    accessor: "lifeCycleDate",
    Header: "Life Cycle Date",
    width: 169,
    type: "date",
  },
  {
    accessor: "machineMacAddress",
    Header: "Machine Mac Address",
    width: 200,
  },
  {
    accessor: "firstLevelManager",
    Header: "First Level Manager",
    width: 200,
  },
  {
    accessor: "firstLevelManagerEmail",
    Header: "First Level Manager Email",
    width: 250,
  },
  {
    accessor: "secondLevelManager",
    Header: "Second Level Manager",
    width: 200,
  },
  {
    accessor: "secondLevelManagerEmail",
    Header: "Second Level Manager Email",
    width: 250,
  },
  {
    accessor: "startDate",
    Header: "Start Date",
    width: 169,
    type: "date",
  },
  {
    accessor: "terminatedDate",
    Header: "Terminated Date",
    width: 169,
    type: "date",
  },
  {
    accessor: "isTelecommuter",
    Header: "Is Telecommuter",
    width: 200,
    type: "boolean",
  },
  {
    accessor: "buildSite",
    Header: "Build Site",
    width: 200,
  },
  {
    accessor: "isDualUser",
    Header: "Dual User",
    width: 200,
    type: "boolean",
  },
  {
    accessor: "userAcceptanceTesting",
    Header: "User Acceptance Testing",
    width: 250,
    type: "boolean",
  },
  {
    accessor: "hasAlternateUseDevice",
    Header: "Alternate Use Device",
    width: 200,
    type: "boolean",
  },
  {
    accessor: "lockType",
    Header: "Lock Type",
    width: 150,
    dataType: "Integer",
  },
  {
    accessor: "isManual",
    Header: "Manual",
    width: 150,
    type: "boolean",
  },
  {
    accessor: "commentsForTechnician",
    Header: "Comments For Technician",
    width: 400,
  },
  {
    accessor: "commentsFromTechnician",
    Header: "Comments From Technician",
    width: 400,
  },
  {
    accessor: "commentsFromPM",
    Header: "Comments From PM",
    width: 400,
  },
  {
    accessor: "commentsForBusiness",
    Header: "Comments For Business",
    width: 400,
  },
  {
    accessor: "lastScanDate",
    Header: "Last Scan Date",
    width: 169,
    type: "date",
  },
  {
    accessor: "overrideDeviceLimit",
    Header: "Override Device Limit",
    width: 150,
    type: "boolean",
  },
  {
    accessor: "hasNewDevice",
    Header: "Has New Device",
    width: 150,
    isHiddenByDefault: true,
    type: "boolean",
  },
  {
    accessor: "hasNewDeviceDate",
    Header: "New Device Date",
    width: 169,
    isHiddenByDefault: true,
    type: "date",
    addEmptyFilters: true,
  },
  {
    accessor: "hasNewDeviceBeenChecked",
    Header: "Has New Device Been Checked",
    width: 180,
    isHiddenByDefault: true,
    type: "boolean",
  },
  {
    accessor: "hasNewDeviceBeenCheckedDate",
    Header: "New Device Checked Date",
    width: 169,
    isHiddenByDefault: true,
    type: "date",
  },
  {
    accessor: "hasNewDeviceDeployed",
    Header: "Has New Device Deployed",
    width: 180,
    isHiddenByDefault: true,
    type: "boolean",
  },
  {
    accessor: "hasNewDeviceDeployedDate",
    Header: "New Device Deployed Date",
    width: 169,
    isHiddenByDefault: true,
    type: "date",
  },
  {
    accessor: "hasOldDeviceReceived",
    Header: "Has Old Device Received",
    width: 150,
    isHiddenByDefault: true,
    type: "boolean",
  },
  {
    accessor: "hasOldDeviceReceivedDate",
    Header: "Old Device Received Date",
    width: 169,
    isHiddenByDefault: true,
    type: "date",
  },
  {
    Header: "Created Date",
    accessor: "createdDate",
    type: "date",
    width: 169,
  },
  {
    Header: "Created By",
    accessor: "createdBy",
    width: 140,
    linkColumn: true,
    linkUrl: "/crm/contact/{value}",
    linkOpenWindow: true,
  },
  {
    Header: "Updated Date",
    accessor: "updatedDate",
    type: "date",
    width: 169,
  },
  {
    Header: "Updated By",
    accessor: "updatedBy",
    width: 140,
    linkColumn: true,
    linkUrl: "/crm/contact/{value}",
    linkOpenWindow: true,
  },
];
